import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';

export default function CookiePolicy() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-lg font-bold text-gray-900 hover:opacity-80" data-testid="cookie-policy-home-link">
            <img src="/specard-logo.png" alt="Specard" className="h-7 object-contain" />
            Specard
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-4 py-10" data-testid="cookie-policy-page">
        <div className="flex items-center gap-3 mb-2">
          <Cookie className="h-6 w-6 text-orange-500" />
          <h1 className="text-2xl font-bold text-gray-900">Cookie Policy</h1>
        </div>
        <p className="text-sm text-gray-500 mb-8">
          Specard currently does not set HTTP cookies. The platform uses local storage and similar browser
          technologies only where needed to support authentication and core application functionality.
        </p>

        <div className="space-y-8 text-gray-700 text-sm leading-relaxed">
          {/* 1 */}
          <section>
            <h2 className="text-base font-semibold text-gray-900 mb-2">What are cookies?</h2>
            <p>
              Cookies are small text files that websites may store on a device to support functionality,
              security, analytics, or preferences.
            </p>
          </section>

          {/* 2 */}
          <section>
            <h2 className="text-base font-semibold text-gray-900 mb-2">How Specard currently works</h2>
            <p>
              Specard does not use HTTP cookies for authentication or session handling. Instead,
              authentication is handled using JWT tokens stored in the browser's local storage. Basic
              user information may also be stored in local storage to support the application experience.
              Session records are managed on the backend.
            </p>
          </section>

          {/* 3 */}
          <section>
            <h2 className="text-base font-semibold text-gray-900 mb-2">Local storage and similar technologies</h2>
            <p>
              The application uses browser storage mechanisms such as local storage to maintain login
              state and support core functionality. These are not cookies&mdash;they are client-side
              key-value stores that remain available until explicitly cleared.
            </p>
          </section>

          {/* 4 */}
          <section>
            <h2 className="text-base font-semibold text-gray-900 mb-2">Managing browser storage</h2>
            <p>
              You can clear stored browser data through your browser's settings or developer tools.
              Please note that doing so will sign you out of the platform and you will need to log in again.
            </p>
          </section>

          {/* 5 */}
          <section>
            <h2 className="text-base font-semibold text-gray-900 mb-2">Future updates</h2>
            <p>
              If Specard begins using HTTP cookies in the future, this page will be updated accordingly
              to reflect the changes.
            </p>
          </section>

          {/* 6 */}
          <section>
            <h2 className="text-base font-semibold text-gray-900 mb-2">Contact</h2>
            <p>
              If you have questions about our data practices, contact us at{' '}
              <a href="mailto:privacy@specard.com" className="text-orange-600 underline" data-testid="cookie-policy-email">
                privacy@specard.com
              </a>.
            </p>
          </section>
        </div>
      </main>
    </div>
  );
}
